module.exports = __webpack_public_path__ + "static/media/sweetwhitephoto.fe0440ba.jpg";